module.exports = __webpack_public_path__ + "static/media/central-heating.22978050.jpg";